import styled from 'styled-components';

export const AdvertCardStylePartnerPage = styled.div`
  .card1 {
    background: linear-gradient(156.76deg, #e0edfe 2.47%, #ffffff 51.68%);
    border: 1px solid #b7d5fe;
  }
  .card2 {
    background: linear-gradient(153.42deg, #dbf0e9 2.26%, #ffffff 51.76%);
    border: 1px solid #aeddce;
  }
`;
